const freeGiftActive = localStorage.getItem('showOfferBanner');
let fetchSection = 'cart-section';
if (typeof cartSections !== 'undefined') {
    fetchSection = cartSections;
}
const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback(...args);
        }, wait);
    };
}

function _onQuantityInputChange(event, id, price) {
    const input = event.target;
    const oldQty = parseInt(input.getAttribute('data-qty'));
    if (!event.target.value) {
        event.target.value = oldQty;
    }
}


function _onQuantityKeyUp(event, id, price) {
    const input = event.target;
    const row = document.getElementById(id);
    const oldQty = parseInt(input.getAttribute('data-qty'));
    if (event.target.value.length && event.target.value == 0) {
        event.target.value = oldQty;
        return;
    }
    if (event.target.value) {
        console.log(isNaN(event.target.value), event.target.value);
        _updateQty(input, id, event.target.value, oldQty, row, price);

    }
}

const onQuantityKeyUp = debounce(_onQuantityKeyUp, 500);
const onQuantityInputChange = debounce(_onQuantityInputChange, 500);

async function updateQuantity(id, price, subtract = false) {
    toggleBusy(id);
    const input = document.getElementById('Quantity-' + id);
    let qty = parseInt(input.value);
    const oldQty = parseInt(input.getAttribute('data-qty'));
    if (subtract) {
        qty--;
    } else {
        vwoAddToCart();
        qty++;
    }
    if (qty < 1) {
        qty = 1;
    }

    const row = document.getElementById(id);
    input.value = qty;
    input.setAttribute('data-qty', qty);

    updateCartBadge(qty - oldQty);

    console.log(qty, oldQty);
    if (qty === 1 && qty === oldQty) {
        toggleBusy(id);
        return;
    }
    return _updateQty(input, id, qty, oldQty, row, price);
}


function vwoAddToCart() {
    window.VWO = window.VWO || [];
    VWO.event = VWO.event || function () {
        VWO.push(["event"].concat([].slice.call(arguments)))
    };

    // Replace the property values with your actual values
    VWO.event("addToCart", {
        "product": 1
    });
}

function _updateQty(input, id, qty, oldQty, row, price) {
    row.classList.add('active');

    const data = {
        updates: {
            [id]: qty,
        }, sections: fetchSection,
    }


    return fetch('/cart/update.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async (response) => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }
        const discountedItemCart = await processDiscountData();
        const body = await response.json();
        if (discountedItemCart) {
            updateCartData(discountedItemCart);
        } else {
            updateCartData(body);
        }
        // addDiscountProduct();
        row.classList.remove('active');
        return response;
    }).catch((error) => {
        console.log(error);
        toggleBusy(id);
        input.value = oldQty;
        alert('An error occurred while processing your request. Please try again later.');
        row.classList.remove('active');
        return error;
    });
}

async function processDiscountData() {
    return;
    const req = await fetch('/cart.js', {
        headers: {
            'Content-Type': 'application/json'
        },
    });
    const res = await req.json();
    const hasItemAdded = res.items.find((item) => {
        return item.properties?._tired_free_efa && !item.selling_plan_allocation;
    });
    let total = res.total_price;
    if (hasItemAdded) {
        total = total - (hasItemAdded.final_line_price / hasItemAdded.quantity);
    }
    console.log(total);
    if (total >= 100 * 100) {
        if (!hasItemAdded) {
            const req = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        "id": 31283306102895,
                        "quantity": 1,
                        "properties": {
                            "_tired_free_efa": true,
                        }
                    }],
                    sections: 'cart-section',
                })
            });
            return await req.json();
        }
    } else {
        if (hasItemAdded) {
            const req = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: hasItemAdded.key,
                    quantity: 0,
                    sections: 'cart-section',
                })
            });
            return await req.json();
        }
    }
    console.log(res);
}


async function addDiscountProduct() {
    console.log('calculating');
    let cartTotal = 0;
    document.querySelectorAll('#cart-header-container .cart-item-total .cart-item-total').forEach((i) => {
        cartTotal += +i.textContent.replace('$', '');
    });
    const discountAdded = document.querySelector('.item-container.discounted');
    console.log('calculating 2', freeGiftActive, cartTotal, discountAdded);
    if (freeGiftActive && cartTotal >= 50 && !discountAdded) {
        document.querySelector('.free-offer-msg').classList.add('show');
        fetch('/cart/add.js', {
            method: 'POST', headers: {
                'Content-Type': 'application/json'
            }, body: JSON.stringify({
                items: [{
                    "id": 41107161219183, "quantity": 1
                }], sections: fetchSection,
            })
        }).then(async () => {
            setTimeout(() => {
                fetch('/?section_id=cart-section', {
                    method: 'GET', headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(async (response) => {
                    const body = await response.text();
                    console.log('calculating 4');
                    document.getElementById('cart-header-container').innerHTML = body;
                    updateCartBadge(1);
                }).catch((error) => {
                    console.log(error);
                    alert('An error occurred while processing your request. Please try again later.');
                });
            }, 500);
        }).catch((error) => {
            console.log(error);
            alert('An error occurred while processing your request. Please try again later.');
        });

    }
}


async function deleteItem(key, productId) {
    toggleBusy(key);
    const input = document.getElementById('Quantity-' + key);

    const qty = +input.getAttribute('data-qty');
    updateCartBadge(-qty);

    const data = {
        updates: {
            [key]: 0,
        }, sections: fetchSection,
    }


    updatedAddedProducts(productId);
    fetch('/cart/update.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async response => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }
        const discountedItemCart = await processDiscountData();
        toggleBusy(key);
        const body = await response.json();
        console.log(body);
        if (discountedItemCart) {
            updateCartData(discountedItemCart);
        } else {
            updateCartData(body);
        }
        cartProcessing = false;
    }).catch((error) => {
        console.log(error);
        updateCartBadge(qty);
        console.log(document.getElementById('cart-trigger'));
        cartProcessing = false;
        toggleBusy(key);
        alert('An error occurred while processing your request. Please try again later.');
    });

}


function updateCartBadge(quantity, noToggle=false) {
    const cart = document.querySelector('.cart-count');
    const badge = +cart.textContent || 0;
    cart.textContent = (+badge) + quantity;
    if(!noToggle) {
        document.getElementById('cart-container')?.classList?.add('active');
        toggleBodyOverflow();
    }
}

// The page lock follows the drawer: locked on phones while it's open, free once it's closed. It used to
// flip on every call, so removing an item or changing a quantity with the drawer open (both call
// updateCartBadge) unlocked it, and closing the drawer then locked the page (Adam, 27 Oct: "I can't
// scroll after adding it to the plan").
function toggleBodyOverflow(){
    const open = !!document.getElementById('cart-container')?.classList.contains('active');
    const lock = open && window.innerWidth <= 767;
    document.body.classList.toggle('stay-fixed', lock);
    document.documentElement.classList.toggle('stay-fixed', lock);
}

function upgradeItem(key, quantity, selling_plan = null) {
    console.log('upgradeItem', key, quantity, selling_plan);
    toggleBusy(key);
    const data = {
        id: key, quantity, selling_plan, sections: fetchSection,
    }

    const row = document.getElementById(key);
    row.classList.add('active');

    return fetch('/cart/change.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async (response) => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }

        const body = await response.json();
        console.log('awaiting');
        const discountedItemCart = await processDiscountData();
        console.log('done');
        if (discountedItemCart) {
            updateCartData(discountedItemCart);
        } else {
            updateCartData(body);
        }
        row.classList.remove('active');
        return response;
    }).catch((error) => {
        toggleBusy(key);
        console.log(error);
        // input.value = oldQty;
        alert('An error occurred while processing your request. Please try again later.');
        row.classList.remove('active');
        return error;
    });


}


function updateCartData(data) {
    if (typeof cartContainer == 'undefined') {
        document.querySelector('.sidebar-cart').innerHTML = data.sections[fetchSection];
    } else {
        document.querySelector(cartContainer).innerHTML = data.sections[fetchSection];
    }
    // document.getElementById('cart-items-count').textContent = data.item_count;
    /* The re-render brings back an empty #cart-recommendations, so the cards
       are asked for again. */
    loadRecommendations(relatedProductId);
}

/* The quantity pill picks a number rather than stepping to it, so it needs a
   set where updateQuantity() has an increment. Everything else — the request,
   the busy row, the re-render — is _updateQty's, unchanged. */
function setQuantity(key, quantity) {
    const input = document.getElementById('Quantity-' + key);
    if (!input) return;

    const qty = parseInt(quantity, 10);
    const oldQty = parseInt(input.getAttribute('data-qty'), 10);
    if (!qty || qty === oldQty) return;

    toggleBusy(key);
    input.value = qty;
    input.setAttribute('data-qty', qty);
    updateCartBadge(qty - oldQty, true);

    return _updateQty(input, key, qty, oldQty, document.getElementById(key), 0);
}

function toggleBusy(key) {
    document.getElementById(key).classList.toggle('active');
}


/* Shopify's own recommendations endpoint. intent=complementary is what the
   Search & Discovery app's "complementary products" writes, so a merchandiser's
   picks win the moment they exist; intent=related is Shopify's automatic set,
   asked for second so the block is never empty before anyone curates one. */
async function recommendedProducts(productId) {
    for (const intent of ['complementary', 'related']) {
        try {
            const req = await fetch('/recommendations/products.json?limit=6&intent='
                + intent + '&product_id=' + productId);
            if (!req.ok) continue;
            const products = ((await req.json()).products || [])
                .filter((product) => product.available && !addedProducts.includes(product.id));
            if (products.length) return products;
        } catch (error) {
            console.log(error);
        }
    }
    return [];
}

/* The cart re-renders the whole snippet, so this box comes back empty after
   every change and the cards used to vanish for as long as the request took.
   The last set is kept and put straight back first, so the row never blanks —
   and when nothing that decides the set has changed, there is no request at
   all and the cards simply stay put. */
var recsCache = { key: '', html: '' };

/* "For even better results" is three fixed products for the moment, rendered by
   snippets/new-cart.liquid rather than fetched. Everything below is the dynamic
   set and is left whole: set this to true and the block goes back to Shopify's
   recommendations, which is the only change needed. */
const NC_DYNAMIC_RECS = false;

async function loadRecommendations(productId) {
    if (!NC_DYNAMIC_RECS) return;

    const box = document.getElementById('cart-recommendations');
    if (!box || !productId) return;

    /* The comma-fenced product ids the drawer put on the box, which is how a
       card knows to draw the tick instead of the bag. See the same list in
       snippets/new-cart.liquid, which renders the fixed set from it. */
    const inCart = box.dataset.ncInCart || '';

    /* What the set depends on: the line it is recommending against, what is
       already in the cart and therefore filtered out, and which of the cards
       are in the cart and so drawn ticked. The last of those is why the cart
       list is part of the key — without it a cached row could come back
       ticking a product that has since been taken out. */
    const key = productId + ':' + addedProducts.join(',') + ':' + inCart;

    if (recsCache.html) {
        box.innerHTML = recsCache.html;
        box.hidden = false;
        if (recsCache.key === key) return;
    }

    const products = (await recommendedProducts(productId)).slice(0, 2);

    /* Re-rendered again while the request was out: whatever is on the page now
       is the box to write into, not the one captured above. */
    const live = document.getElementById('cart-recommendations');
    if (!live) return;

    if (!products.length) {
        recsCache = { key: key, html: '' };
        live.innerHTML = '';
        live.hidden = true;
        return;
    }

    recsCache = {
        key: key,
        html: '<h3 class="nc-recs-title">For even better results</h3>'
            + '<div id="recommendation-cards">'
            + products.map((product) => relatedProductMarkup(product, inCart)).join('')
            + '</div>'
    };

    live.innerHTML = recsCache.html;
    live.hidden = false;
}

function updatedAddedProducts(productId) {
    try {
        if (!addedProducts.includes(productId)) {
            addedProducts.push(productId);
            relatedProductId = productId;
            loadRecommendations(relatedProductId);
        } else {
            addedProducts = addedProducts.filter((id) => id !== productId);
            if (addedProducts.length > 0) {
                relatedProductId = addedProducts[addedProducts.length - 1];
                loadRecommendations(relatedProductId);
            } else {
                // document.getElementById('cart-recommendations').innerHTML = '';
            }
        }
    } catch (e) {
        console.log(e);
    }
}


/* Titles come from the shop's own catalogue via Shopify's endpoint, but they
   are still interpolated into markup and into attributes, so they are escaped. */
function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[character]));
}

/* `inCart` is the comma-fenced list of product ids in the cart. The fences are
   part of the test: ',123,' cannot be found inside 1234, where '123' could. */
function relatedProductMarkup(product, inCart) {
    const title = escapeHtml(product.title);
    const image = escapeHtml(product.featured_image || (product.images || [])[0] || '');
    const price = '$' + (product.price / 100).toFixed(2);
    const isInCart = String(inCart || '').includes(',' + product.id + ',');

    /* In the cart, the button is the tick and nothing else — disabled rather
       than a control that looks pressable and does nothing, and named for what
       it is saying. Removing the line re-renders the drawer, which rebuilds
       this without the mark. */
    const action = isInCart
        ? `disabled aria-label="${title} is already in your cart"`
        : `aria-label="Add ${title} to cart, ${price}"`
          + ` onclick="addToCartRelated(${product.variants[0].id}, ${product.id}, this)"`;

    return `
    <div class="nc-rec">
        <a class="nc-rec-tile" href="${escapeHtml(product.url)}" tabindex="-1" aria-hidden="true">
            <img src="${image}" alt="" loading="lazy">
        </a>
        <button type="button" class="nc-rec-add${isInCart ? ' is-in-cart' : ''}" ${action}>
            <svg viewBox="0 0 14 13" fill="none" aria-hidden="true" focusable="false">
                <g stroke="currentColor" stroke-width="0.93" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10.16 4.52H2.24a1.05 1.05 0 0 0-1.04 1.23l.76 4.58a1.05 1.05 0 0 0 1.04.88h6.4a1.05 1.05 0 0 0 1.04-.88l.76-4.58a1.05 1.05 0 0 0-1.04-1.23Z"/>
                    <path d="M3.41 4.52v-.56a2.79 2.79 0 0 1 5.57 0v.56"/>
                </g>
                <circle cx="10.22" cy="4.65" r="3.72" fill="var(--nc-rec-knock, #FFFFFF)"/>
                <g stroke="currentColor" stroke-width="0.93" stroke-linecap="square">
                    <path d="M8.36 4.65h3.72"/>
                    <path d="M10.22 6.51V2.79"/>
                </g>
            </svg>
            <svg class="nc-rec-tick" viewBox="0 0 14 13" fill="none" aria-hidden="true" focusable="false">
                <path d="M2.6 6.9 5.5 9.7l6-6.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <p class="nc-rec-title">${title}</p>
        <p class="nc-rec-price">${price}</p>
    </div>`;
}

/* `button` is the add button that was pressed, passed as `this` from the card.
   The whole cart is replaced the moment the add lands, which would take the
   button with it before anything could be seen — so the tick is held for a
   beat first. NC_REC_ADDED_MS is that beat; the request is already away, so it
   costs nothing but the wait. Called from anywhere else with no button, it
   behaves exactly as it did. */
const NC_REC_ADDED_MS = 420;

async function addToCartRelated(variantId, productId, button) {
    /* Double-press guard: the row is about to be replaced, and two adds would
       put two of the product in the cart. */
    if (button && button.classList.contains('is-adding')) return;
    if (button) button.classList.add('is-adding');

    updatedAddedProducts(productId);
    const data = {
        items: [{
            "id": variantId, "quantity": 1,
            "properties": {"_pdp": window.atV11 ? 'v11' : 'alt'}
        }], sections: fetchSection,
    };
    fetch('/cart/add.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async (response) => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }

        const body = await response.json();
        console.log(body);

        /* Already open, or on the cart page: the badge moves, the drawer does not.
           Ahead of the re-render so the count and the tick land together. */
        updateCartBadge(1, true);

        const settle = () => {
            /* Was #cart-header-container, which only exists on the cart page — from
               the drawer this wrote nowhere. updateCartData serves both. */
            updateCartData(body);
        };

        if (!button) return settle();
        button.classList.remove('is-adding');
        button.classList.add('is-added');
        setTimeout(settle, NC_REC_ADDED_MS);
    }).catch((error) => {
        if (button) button.classList.remove('is-adding', 'is-added');
        alert('An error occurred while processing your request. Please try again later.');
    });

}


function truncateString(str) {
    if (str.length > 35) {
        return str.slice(0, 35) + "...";
    } else {
        return str;
    }
}

loadRecommendations(relatedProductId);

async function clearCart(force = true) {
    if (!force && cleared) return;

    cleared = false;
    await fetch('/cart/clear.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify('') // for no data you can omit the body or pass an empty object
    })
        .then(response => response.json())
        .then(data => {
            processing = false;
            cleared = true;
        })
        .catch((error) => {
            processing = false;
        });

}


document.getElementById('cart-trigger').addEventListener('click', (e) => {
    e.preventDefault();
    console.log('clicked');
    if (location.pathname === '/cart') {
        location.href = '/cart';
    } else {
        document.getElementById('cart-container').classList.toggle('active');
        toggleBodyOverflow()
    }
});

function toggleSidebarCart() {
    document.getElementById('cart-container').classList.toggle('active');
    toggleBodyOverflow()
}

document.getElementById('cart-backdrop')?.addEventListener('click', () => {
    document.getElementById('cart-container').classList.toggle('active');
    toggleBodyOverflow()
})
